import { render, staticRenderFns } from "./ArchivesViewerListSection.vue?vue&type=template&id=edc61b2a&scoped=true&"
import script from "./ArchivesViewerListSection.vue?vue&type=script&lang=js&"
export * from "./ArchivesViewerListSection.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesViewerListSection.vue?vue&type=style&index=0&id=edc61b2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc61b2a",
  null
  
)

export default component.exports